import React from "react";
import PropTypes from "prop-types";
import Modal from "./modal";
import useOpenClose from "../../hooks/use-open-close";
import Button from "../elements/button";

const ModalTrigger = ({
  buttonText,
  buttonProps = { type: "default" },
  children,
  size,
  closeOnOutsideClick,
  ...rest
}) => {
  const [isOpen, open, close] = useOpenClose(false);
  const triggerRef = React.useRef();

  const openModal = () => {
    open();
    triggerRef.current.classList.remove(`et--button-${buttonProps.type}--visited`);
    triggerRef.current.classList.add(`et--button-${buttonProps.type}--active`);
  };

  const closeModal = () => {
    close();
    triggerRef.current.classList.replace(
      `et--button-${buttonProps.type}--active`,
      `et--button-${buttonProps.type}--visited`
    );
  };

  return (
    <>
      <Button {...buttonProps} onClick={openModal} ref={triggerRef}>
        {buttonText}
      </Button>
      <Modal closeModal={closeModal} isOpen={isOpen} {...rest} size={size} closeOnOutsideClick={closeOnOutsideClick}>
        {typeof children === "function" ? children({ closeModal }) : children}
      </Modal>
    </>
  );
};

ModalTrigger.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  size: PropTypes.string,
  closeOnOutsideClick: PropTypes.bool,
  buttonProps: PropTypes.object,
  buttonText: PropTypes.string,
};

export default ModalTrigger;
